module.exports = __webpack_public_path__ + "static/media/icon_basic_manage.251d78c6.svg";